// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","card":"PurchasingPower_card__3MAUl","heading":"PurchasingPower_heading__31Z7u","grid":"PurchasingPower_grid__1_lsw"};